import { useMutation } from '@tanstack/react-query';

import { useResetUserInfo } from '@/features/users';

import { saveImage } from '../api';

export const useStoreImage = () => {
  const resetUserInfo = useResetUserInfo();

  return useMutation({
    mutationKey: ['saveImage'],
    mutationFn: saveImage,
    onSuccess: async (_data) => {
      await resetUserInfo();
    },
    onError: (_error) => {},
  });
};
